import { render } from "./TableScrollHeader.vue?vue&type=template&id=0ebda17c&scoped=true"
import script from "./TableScrollHeader.vue?vue&type=script&lang=js"
export * from "./TableScrollHeader.vue?vue&type=script&lang=js"

import "./TableScrollHeader.vue?vue&type=style&index=0&id=0ebda17c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebda17c"]])

export default __exports__